var _defs, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var SvgLeftr = function SvgLeftr(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 149,
    height: 150
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    x: "-5%",
    y: "-3.5%",
    width: "109.9%",
    height: "109.9%",
    filterUnits: "objectBoundingBox",
    id: "left_r_svg__a"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 2,
    "in": "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2,
    "in": "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.2 0",
    "in": "shadowBlurOuter1"
  })), /*#__PURE__*/React.createElement("filter", {
    x: "-4.3%",
    y: "-2.8%",
    width: "108.5%",
    height: "108.5%",
    filterUnits: "objectBoundingBox",
    id: "left_r_svg__c"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5,
    "in": "SourceAlpha",
    result: "shadowBlurInner1"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1,
    "in": "shadowBlurInner1",
    result: "shadowOffsetInner1"
  }), /*#__PURE__*/React.createElement("feComposite", {
    "in": "shadowOffsetInner1",
    in2: "SourceAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1,
    result: "shadowInnerInner1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.8 0",
    "in": "shadowInnerInner1"
  })), /*#__PURE__*/React.createElement("filter", {
    x: "-8%",
    y: "-4.6%",
    width: "115.9%",
    height: "118.3%",
    filterUnits: "objectBoundingBox",
    id: "left_r_svg__d"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 7,
    "in": "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2,
    "in": "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.5 0",
    "in": "shadowBlurOuter1"
  })), /*#__PURE__*/React.createElement("filter", {
    x: "-7.5%",
    y: "-4.2%",
    width: "115.1%",
    height: "117.4%",
    filterUnits: "objectBoundingBox",
    id: "left_r_svg__f"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4.5,
    "in": "SourceAlpha",
    result: "shadowBlurInner1"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1,
    "in": "shadowBlurInner1",
    result: "shadowOffsetInner1"
  }), /*#__PURE__*/React.createElement("feComposite", {
    "in": "shadowOffsetInner1",
    in2: "SourceAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1,
    result: "shadowInnerInner1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.3 0",
    "in": "shadowInnerInner1"
  })), /*#__PURE__*/React.createElement("ellipse", {
    id: "left_r_svg__b",
    cx: 70.5,
    cy: 70.971,
    rx: 70.5,
    ry: 70.971
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "left_r_svg__e",
    cx: 70.5,
    cy: 70.941,
    rx: 59.746,
    ry: 60.201
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(4 2)"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#000",
    filter: "url(#left_r_svg__a)",
    xlinkHref: "#left_r_svg__b"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#002D41",
    xlinkHref: "#left_r_svg__b"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#000",
    filter: "url(#left_r_svg__c)",
    xlinkHref: "#left_r_svg__b"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(4 2)"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#000",
    filter: "url(#left_r_svg__d)",
    xlinkHref: "#left_r_svg__e"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#414F76",
    xlinkHref: "#left_r_svg__e"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#000",
    filter: "url(#left_r_svg__f)",
    xlinkHref: "#left_r_svg__e"
  })), /*#__PURE__*/React.createElement("g", {
    className: "left_r_svg__virtualBox_TextInSvg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M69.98 88.194v-5.488h22.414c2.47 0 4.492-2.041 4.492-4.536v-9.207c0-2.495-2.022-4.536-4.492-4.536H69.98v-5.533c0-3.13-3.144-4.672-4.94-2.495L52.866 71.05c-1.123 1.36-1.123 3.583 0 4.944l12.172 14.65c1.797 2.222 4.941.68 4.941-2.45z",
    fill: "#FFF"
  })))));
};

export default SvgLeftr;